export default "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiaW1hZ2VzL2FwcGxlLXRvdWNoLWljb24tcHJlY29tcG9zZWQucG5nIjs="